<style scoped>
    .layout-wrapper{
        position: absolute;
        width: 100%;
        height: 100%;
        min-width: 1200px;
        min-height: 600px;
    }
    /* 页面头部导航栏 */
    .header-wrapper {
        background: linear-gradient(123deg, rgba(36, 104, 203, 1) 0%,
        rgba(36, 104, 203, 1) 0%, rgba(10, 59, 130, 1) 100%,
        rgba(10, 59, 130, 1) 100%);
        /*height: 64px;*/
        /*line-height: 64px;*/
        padding: 0 15px;
        /*height: 60px;*/
        /*line-height: 60px;*/
    }

    .header-logo {
        font-weight: 500;
        font-size: 18px;
        color: #FFFFFF;
        padding-left: 60px;
        background-image: url("../../assets/portal/portal-gh.png");
        background-repeat: no-repeat;
        background-position: 5px center;
        background-size: 30px;
    }
    .header-logo:before{
        content: '';
        width: 1px;
        height: 20px;
        position: absolute;
        left: 45px;
        top: 20px;
        background-color: #ffffff;
        z-index: 1;

    }
    /* 顶部导航栏 */
    .header-left{
        display: flex;
        flex: 1;
    }
    .header-nav{
        margin-left: 30px;
        margin-right: auto;
    }
    .header-right{
        padding-left: 20px;
    }
    .header-user{
        color: #fff;
        font-weight: 400;
        font-size: 16px;
        margin: 0 10px;
    }
    .icon-container{
        font-size: 20px;
    }

</style>
<style>
    /* 顶部导航栏 */
    .header-left.ivu-menu-dark{
        background: transparent;
    }
    .header-left.ivu-menu-dark.ivu-menu-horizontal .ivu-menu-item .nav-name{
        padding: 3px 0;
        font-size: 16px;
    }
    .header-left.ivu-menu-dark.ivu-menu-horizontal .ivu-menu-item-active .nav-name{
        border-bottom: 2px solid #ffffff;
    }
</style>
<template>
    <Layout class="layout-wrapper">
        <!-- <Header class="header-wrapper ajFlex">
            <Menu mode="horizontal" theme="dark"
                  ref="navMenu"
                  :active-name="actNavName"
                  @on-select="handleNav" class="header-left">
                <div class="header-logo">
                    <span v-if="userInfo && userInfo.titleName">{{areaName}}建筑工人{{userInfo.titleName}}管理系统</span>
                    <span v-else>{{areaName}}建筑工人实名制管理系统</span> 
                </div>
                <div class="header-nav">
                    <MenuItem v-for="nav in navList" :name="nav.url" :key="nav.id">
                        <span class="nav-name">{{nav.name}}</span>
                    </MenuItem>
                </div>
            </Menu>
            <div class="aFlex header-right">
                <Dropdown transfer-class-name="header-drop" trigger="click" @on-click="dropdownSelect" transfer>
                    <a class="header-user" href="javascript:void(0)" >
                        <span >{{users.userName}}</span>
                        <span class="icon-container"><Icon type="ios-arrow-down" /></span>
                    </a>
                    <DropdownMenu slot="list">
                        <DropdownItem name="changePassword">修改密码</DropdownItem>
                        <DropdownItem name="back">返回产品</DropdownItem>
                        <DropdownItem name="exit">退出</DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
        </Header> -->
        <router-view></router-view>
    </Layout>
</template>
<script>
    import {mapState,mapActions} from 'vuex';
    export default {
        data () {
            return {
                // 激活的导航
                userInfo:JSON.parse(localStorage.getItem('userInfo')),
                actNavName:'',
                areaName: localStorage.getItem('areaName'),
            };
        },
        computed: {
            ...mapState(['navList','users']),
        },
        watch:{
            '$route': function (to, from) {
                // console.log(this.$route)
            },
        },
        created(){            
            this.actNavName=this.$route.matched[0].name;
            this.GetDict();
            // this.Get_Dict();
            this.GetArea();
            // this.GetCitys();
            // 获取菜单
            this.getMenuLists();
        },
        mounted(){

        },
        methods: {
            ...mapActions(['GenerateRoutes','GetDict','GetArea']),
            // 获取菜单
            getMenuLists(){
                this.GenerateRoutes().then((res)=>{
                    this.setMenu(this.actNavName);
                    if(res.data){

                    }
                });
            },
            //设置菜单
            setMenu(){
                this.$nextTick(()=>{
                    this.$refs.navMenu.updateActiveName();
                });
            },
            // 选择导航菜单项
            handleNav(name){
                if(!name){
                    // this.$router.push({
                    //     path:'/base/404'
                    // });
                    this.$Message.warning('暂无该模块!');

                    return;
                }
                let filterMenu = this.navList.filter((item)=> {
                    return item.url === name;
                });
                if(filterMenu && filterMenu.length>0){
                    // iframe页面
                    if(filterMenu[0].iframe){
                        // 保存当前的导航菜单name
                        // localStorage.setItem('actNavName',filterMenu[0].iframe);
                        // console.log(name)
                        if(filterMenu[0].iframe==='0'){
                            window.open(filterMenu[0].url);
                        }else {
                            this.$router.push({
                                name: name,
                                params:{
                                    path:name
                                }
                            });
                        }
                    }else {
                        this.$router.push({
                            name: name,
                        });
                    }
                }else {
                    this.$Message.warning('无效地址!');
                    // this.$router.push({
                    //     path:'/base/404'
                    // });
                }
            },

            /*下拉选择*/
            dropdownSelect(name){
                switch (name){
                    case 'changePassword':
                        this.$router.push({
                            name:'changePassword',
                        });
                        break;
                    case 'back':
                        window.location.href = `http://${location.hostname}:7090`
                        break;
                    case 'exit':
                        this.$store.dispatch('users/loginOUt', {
                            'router': this.$router,
                        });
                        break;
                }
            },
        }
    };
</script>
